// extracted by mini-css-extract-plugin
export default {"menu":"NavBar_menu__xwXYY","visible":"NavBar_visible__CKLDo","hidden":"NavBar_hidden__tIOQZ","title":"NavBar_title__pq46E"};